import styled from 'styled-components';

export const RowContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 16px;

  &:last-child {
    padding-bottom: 0;
  }
`;

export const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
`;

export const RightContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
`;
